import Joi from 'joi';
import { isBefore, isValid, isWeekend } from 'date-fns';
import { LEAVE_POST_TYPES_ALLOWING_WEEKEND } from '../hooks/domain/useLeavePost';

const today = new Date();
today.setHours(0, 0, 0, 0);

const isWeekendAllowed = (helpers) => LEAVE_POST_TYPES_ALLOWING_WEEKEND.includes(
  helpers?.state?.ancestors?.[0]?.type?.value,
);

const isValidStartDateForPost = (start, helpers) => {
  if (!isValid(start)) return helpers.error('date.invalid');
  if (isWeekend(start) && !isWeekendAllowed(helpers)) return helpers.error('date.weekend');

  return start;
};

const isValidEndDateForPost = (end, helpers) => {
  if (!isValid(end)) return helpers.error('date.invalid');
  const selectedStartDate = helpers?.state?.ancestors?.[0]?.startDate;
  if (selectedStartDate && isBefore(end, selectedStartDate)) return helpers.error('date.startBeforeEnd');
  if (isWeekend(end) && !isWeekendAllowed(helpers)) return helpers.error('date.weekend');

  return end;
};

const postLeavePostSchema = {
  startDate: Joi.date()
    .custom(isValidStartDateForPost)
    .required()
    .messages({
      'any.required': 'common.form.requiredField',
      'date.base': 'common.form.requiredField',
      'date.empty': 'common.form.requiredField',
      'date.invalid': 'common.form.date.invalid',
      'date.weekend': 'common.form.date.weekendLeave',
    }),
  endDate: Joi.date()
    .custom(isValidEndDateForPost)
    .required()
    .messages({
      'any.required': 'common.form.requiredField',
      'date.base': 'common.form.requiredField',
      'date.empty': 'common.form.requiredField',
      'date.startBeforeEnd': 'common.form.date.startBeforeEnd',
      'date.weekend': 'common.form.date.weekendLeave',
    }),
  type: Joi.object({ value: Joi.string(), label: Joi.string() })
    .messages({
      'object.base': 'common.form.requiredField',
    }),
  startDateSlot: Joi.string().messages({
    'string.base': 'common.form.requiredField',
    'string.empty': 'common.form.requiredField',
  }),
  endDateSlot: Joi.string().messages({
    'string.base': 'common.form.requiredField',
    'string.empty': 'common.form.requiredField',
  }),
  comment: Joi.string().max(255).allow('').messages({
    'string.max': 'common.form.comment',
  }),
};

export const postLeavePostSchemaAny = Joi.object({
  resourceId: Joi.object({
    value: Joi.string(),
    label: Joi.string(),
    icon: Joi.object().allow(null),
  })
    .messages({
      'object.base': 'common.form.requiredField',
    }),
  ...postLeavePostSchema,
});

export const postLeavePostSchemaOwn = Joi.object({
  resourceId: Joi.object({
    value: Joi.string(),
    label: Joi.string(),
    icon: Joi.object().allow(null),
  }).allow(null),
  ...postLeavePostSchema,
});
